export default __webpack_public_path__ + "static/media/13_mobility_flows.2190940b.png";